import labelInputMixin from "../_mixin";
export default {
  name: "commonInputAutocomplete",
  mixins: [labelInputMixin],
  methods: {
    renderInput(h, data) {
      return h("el-autocomplete", data);
    }
  },
  mounted() {
    // document.querySelectorAll('.el-icon-time').forEach(item => item.style = `display: none`)
  }
};
